import type { PersonaConfigurationActionArgs } from "../model/types/personaConfigurationActionArgs"
import {
  readBoolean,
  readJsonObject,
  readNumber,
  readString,
  readStringAllowEmpty,
  readStringArray,
} from "./actionArgumentReaders"

/** Preserve explicit clears and falsy settings in the server-confirmed action. */
export function readPersonaConfiguration(
  args: Record<string, unknown>,
): PersonaConfigurationActionArgs {
  const nullable = <T>(key: string, read: () => T) =>
    args[key] === null ? null : read()

  const config: PersonaConfigurationActionArgs = {
    background_sound: readString(args, "background_sound"),
    background_sound_volume: readNumber(args, "background_sound_volume"),
    voice_volume: nullable("voice_volume", () =>
      readNumber(args, "voice_volume"),
    ),
    voice_speed: nullable("voice_speed", () => readNumber(args, "voice_speed")),
    wait_seconds: readNumber(args, "wait_seconds"),
    conversation_initiation: readString(args, "conversation_initiation"),
    interruption_rate: readString(args, "interruption_rate"),
    multi_language_stt: readBoolean(args, "multi_language_stt"),
    hold_music_timeout_seconds: nullable("hold_music_timeout_seconds", () =>
      readNumber(args, "hold_music_timeout_seconds"),
    ),
    situate_speaker: nullable("situate_speaker", () =>
      readString(args, "situate_speaker"),
    ),
    audio_degradation: nullable("audio_degradation", () =>
      readJsonObject(args, "audio_degradation"),
    ),
    silent_mode: nullable("silent_mode", () =>
      readBoolean(args, "silent_mode"),
    ),
    multi_phone_config: nullable("multi_phone_config", () =>
      readJsonObject(args, "multi_phone_config"),
    ),
    initialization_parameters: nullable("initialization_parameters", () =>
      readJsonObject(args, "initialization_parameters"),
    ),
    custom_persona_data: nullable("custom_persona_data", () =>
      readStringAllowEmpty(args, "custom_persona_data"),
    ),
    voice: nullable("voice", () => readString(args, "voice")),
    custom_voice_id: nullable("custom_voice_id", () =>
      readString(args, "custom_voice_id"),
    ),
    tags: readStringArray(args, "tags"),
  }
  return Object.fromEntries(
    Object.entries(config).filter(([, value]) => value !== undefined),
  )
}
